document.addEventListener('DOMContentLoaded', () => {
  const stickyCart = document.getElementById('sticky-cart-bar');
  const targets = document.querySelectorAll('.main-buy-buttons');

  if (!stickyCart || targets.length < 1) return;
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          stickyCart.classList.remove('visible');
        } else {
          stickyCart.classList.add('visible');
        }
      });
    },
    { threshold: 0.1 }
  );
  targets.forEach((el) => observer.observe(el));
});
